const COMPANY_TYPES = ['agency', 'builder', 'bank'];
export function isCompanyAvatarType(type) {
  return !!type && COMPANY_TYPES.includes(type);
}